/**
 * Every colour role (base + picture kit + all worlds) for each art style. Kept apart from the world registry so code
 * that only needs colours (colouring coach, the client renderer) does not pull in the worlds' drawings.
 */
import { BASE_PALETTE, mergePalettes } from '../art/palette';
import { PICTURE_PALETTE } from '../v2/pictureKit';
import { INTRO_PALETTE } from './intro/palette';
import { ANIMALS_PALETTE } from './animals/palette';
import { NATURE_PALETTE } from './nature/palette';
import { CHARACTERS_PALETTE } from './characters/palette';
import { ANIME_PALETTE } from './anime/palette';
import { CUTE_PALETTE } from './cuteObjects/palette';

/** World palettes in path order (same order as WORLDS). */
export const WORLD_PALETTES = [INTRO_PALETTE, ANIMALS_PALETTE, NATURE_PALETTE, CHARACTERS_PALETTE, ANIME_PALETTE, CUTE_PALETTE];

export const ART_PALETTES = mergePalettes(BASE_PALETTE, PICTURE_PALETTE, ...WORLD_PALETTES);
